// SharedDropdownStyles.js
import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const OptionsList = styled.ul`
  position: absolute;
  top: ${(props) =>
    props.top
      ? `${viewSizeCalculator(props.top)}`
      : `${viewSizeCalculator(4.475)}`};
  ${(props) => (props.right ? "right: 0;" : "left: 0;")}
  height: ${(props) => (props.height ? `${props.height}px` : "fit-content")};
  width: ${(props) =>
    props.customWidth ? `${viewSizeCalculator(props.customWidth)}` : "100%"};
  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  overflow-y: scroll;
  max-height: ${() => `${viewSizeCalculator(27)}`};
  box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  margin: 0;
  padding: ${(props) =>
    props.customPadding ? `${viewSizeCalculator(props.customPadding)}` : 0};
  list-style: none;
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 400;
  z-index: 99;
  /* Add transition styles */
  transform: scaleY(${(props) => (props.isOpen ? 1 : 0)});
  transform-origin: top;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    visibility 0.3s ease ${(props) => (props.isOpen ? "0s" : "0.3s")};
  left: ${() => `${viewSizeCalculator(0.4)}`};

  &::-webkit-scrollbar {
    width: 5px; /* Adjust the width */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc; /* Scrollbar color */
    border-radius: 4px; /* Rounded edges */
  }

  &::-webkit-scrollbar-track {
    background: transparent; /* Scrollbar track */
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }
`;

export const Option = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${() => `${viewSizeCalculator(1)}`}; // 1.25rem
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  /* color: ${({ isSelected }) => (isSelected ? "#E35B42" : "#333")}; */
  color: "#333333";

  cursor: pointer;

  &:hover {
    background-color: #f9f9f9;
  }

  &.highlighted {
    background-color: #f9f9f9;
    // color: #0073e6;
    font-weight: 600;
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }

  border-radius: ${(props) =>
    props.customBorderRadius
      ? `${viewSizeCalculator(props.customBorderRadius)}`
      : "0px"};
`;

export const Checkbox = styled.input`
  appearance: none;
  width: 16px;
  height: 16px;
  background-color: transparent;
  border: 1px solid rgb(144, 144, 144);
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  position: relative;

  &:checked {
    background-color: #E35B42;
    border: 2px solid #E35B42;
  }

  &:checked::after {
    content: "✔";
    color: #fff;
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
  }
`;

export const Title = styled.div`
  height: ${() => `${viewSizeCalculator(2.063)}`};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${() => `${viewSizeCalculator(1.5)} ${viewSizeCalculator(1)}`};

  cursor: default;
`;

export const Text = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 700;
`;

export const SubText = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 400;
  color: #333333;
  opacity: 60%;
  margin-top: ${() => `${viewSizeCalculator(0.25)}`};
  line-height: ${() => `${viewSizeCalculator(1.2)}`}; // 1rem
`;
